import { startBackground } from './app/background';
import { startUILazy } from './app/startUILazy';
import { detectMode } from './xbees/client';

// One bundle, mode chosen at startup (design doc § Surfaces). The OAuth popup callback is the
// only route; everything else is decided by how x-Bees opened the iframe.
if (location.pathname === '/auth/callback') {
  void startUILazy('callback');
} else {
  const mode = detectMode();
  if (mode === 'background') void startBackground();
  else void startUILazy(mode);
}
